import { useEffect, useState } from "react";
import { CloudOff } from "lucide-react";
import { getSyncState } from "@/lib/sync";

const SHOW_AFTER_MS = 3000;

// Floating notice shown when the server can't be reached; data stays safe on the device.
export const OfflineBanner = () => {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && navigator.onLine === false);
  const [unreachable, setUnreachable] = useState(getSyncState().unreachable);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onSync = (e) => setUnreachable(!!(e.detail || getSyncState()).unreachable);
    const onOnline = () => setOffline(false);
    const onOffline = () => setOffline(true);
    window.addEventListener("tl:sync-state", onSync);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("tl:sync-state", onSync);
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  const problem = offline || unreachable;
  useEffect(() => {
    if (!problem) { setVisible(false); return; }
    const t = setTimeout(() => setVisible(true), SHOW_AFTER_MS);
    return () => clearTimeout(t);
  }, [problem]);

  if (!visible) return null;
  return (
    <div
      role="status"
      className="tl-offline-banner fixed left-1/2 -translate-x-1/2 z-50 w-[calc(100%-24px)] max-w-md flex items-start gap-3 px-4 py-3 rounded-2xl bg-[#3B443D] text-[#FDFDFB] shadow-lg animate-in fade-in slide-in-from-bottom-2 duration-300"
      data-testid="offline-banner"
    >
      <CloudOff size={18} strokeWidth={1.75} className="mt-0.5 flex-shrink-0 text-[#D8E0D2]" />
      <div className="text-[13px] leading-snug">
        <div className="font-semibold" data-testid="offline-banner-title">
          {offline ? "Sei senza connessione" : "Non riesco a raggiungere il server"}
        </div>
        <div className="text-[#D8E0D2]" data-testid="offline-banner-text">
          I tuoi dati sono al sicuro: le modifiche restano su questo dispositivo e verranno salvate appena torna la connessione.
        </div>
      </div>
    </div>
  );
};
